import { useState as c, useEffect as s } from "react";
const n = ({
  dropdownWidth: t,
  containerRef: e
}) => {
  const [r, u] = c(t ?? !0);
  return s(() => {
    t && e.current && e.current.getBoundingClientRect().width < t ? u(t) : u(!0);
  }, [t, e.current]), { dropdownMatchSelectWidth: r };
};
export {
  n as default
};
